import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import Icons from "scripts/icons";
import Resources from "scripts/resources";

const Component = ({ user }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { active } = state;
	const { pathname } = useLocation();

	const componentDidUpdate = () => {
		switch (pathname) {
			case "/":
				setState((prevState) => ({
					...prevState,
					active: 1,
				}));
				break;
			case "/jobs":
				setState((prevState) => ({
					...prevState,
					active: 2,
				}));
				break;
			case "/panel/create":
				setState((prevState) => ({
					...prevState,
					active: 3,
				}));
				break;
			default:
				setState((prevState) => ({
					...prevState,
					active: 4,
				}));
				break;
		}
	};

	useEffect(componentDidUpdate, [pathname]);

	return (
		<div className="pwa-footer">
			<Link to="/" className={active === 1 ? "active" : ""}>
				<Icons.Home />
				<span>{Resources.home}</span>
			</Link>
			<Link to="/jobs" className={active === 2 ? "active" : ""}>
				<Icons.Search />
				<span>{Resources.jobs}</span>
			</Link>
			<Link to="/panel/create" className={active === 3 ? "active" : ""}>
				<Icons.AddSquare />
				<span>{`${Resources.add} ${Resources.job}`}</span>
			</Link>
			<Link
				to={user.id ? "/panel" : "/auth"}
				className={active === 4 ? "active" : ""}
			>
				<Icons.FrameCircle />
				<span>{Resources.account}</span>
			</Link>
		</div>
	);
};

export default connect((state) => {
	return {
		user: state.user,
	};
})(Component);
